import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SimpleFlexbox, ProgressBar } from 'ctm-components';
import { pageContext } from 'ctm-util-functions';

import { CarBrandIcon } from '../car_brand_icon/car_brand_icon';
import styles from './progress_footer.css';

class ProgressFooter extends Component {

    constructor(props) {
        super(props);

        // store a local reference to the page schema model
        this.pageSchemaModel = pageContext.getProps().models.pageSchemaModel;
    }

    /**
     * Get the ProgressBar Percentage
     * @returns {Node} ProgressBar Percentage
     */
    getProgressPercentage = () => {
        // store the path of the current route
        const currentLocation = pageContext.getProps().pageState.path;

        // get the journey schema object
        const journeyPages = this.pageSchemaModel.getPageJourneyForProgressBar();
        // added + 1 to the logic to prevent an issue where the index of the first page is 0
        // so with the maths below it would equal 0% and the requirements asked to show a value greater than 0 on the first page
        const currentPageIndex = journeyPages.findIndex((currentPage) => currentPage.path === currentLocation) + 1;
        const totalPages = journeyPages.length;
        if (currentPageIndex + 1 === totalPages) {
            // requirement was to return 99% if its the last page before results
            // sometimes with the maths below would return 98% for example 4
            return 99;
        }
        return Math.round((currentPageIndex / totalPages) * 100);
    };

    /**
     * Returns the Footer Progress Component
     * @returns {Node} Footer Progress Component
     */
    render = () => {
        const { progressBar: { background }, label } = this.props;
        const percentage = this.getProgressPercentage();
        return (
            <footer className={styles.container}>
                <SimpleFlexbox display="flex" container xs={12} contentCenter="xs" itemsCenter="xs" variant="full_height">
                    <CarBrandIcon />
                    <span className={styles.label}>{label}</span>
                    <SimpleFlexbox className={styles.progress_container}>
                        <ProgressBar background={background} percent={percentage} />
                    </SimpleFlexbox>
                    <span className={styles.label}>
                        {percentage}
                        %
                    </span>
                </SimpleFlexbox>
            </footer>
        );
    };

}

ProgressFooter.propTypes = {
    label: PropTypes.string,
    progressBar: PropTypes.shape({
        background: PropTypes.string
    })
};

ProgressFooter.defaultProps = {
    label: 'Progress',
    progressBar: {
        background: 'brand_secondary'
    }
};

export { ProgressFooter };
